import { cn } from "@gettactic/helpers";
import { ChevronUpIcon } from "lucide-react";
import React from "react";

export interface ToolbarButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  isActive?: boolean;
  hasChevron?: boolean;
}

/**
 * A tool button in the bottom dock: fixed square hit area with a filled
 * accent active state. Tools with variants render a trailing chevron.
 */
export const ToolbarButton = React.forwardRef<
  HTMLButtonElement,
  ToolbarButtonProps
>(({ isActive, children, hasChevron, className, ...rest }, ref) => {
  return (
    <button
      ref={ref}
      type="button"
      aria-pressed={isActive}
      className={cn(
        "flex h-10 flex-none items-center justify-center gap-0.5 rounded-xl transition-colors",
        hasChevron ? "px-2.5" : "w-10",
        isActive
          ? "bg-blue-500 text-white"
          : "text-neutral-600 hover:bg-neutral-100 hover:text-neutral-900",
        className
      )}
      {...rest}
    >
      {children}
      {hasChevron ? (
        <ChevronUpIcon
          className={cn(
            "h-3 w-3",
            isActive ? "text-white/70" : "text-neutral-400"
          )}
        />
      ) : undefined}
    </button>
  );
});
ToolbarButton.displayName = "ToolbarButton";
